import { toCheckoutConfirmation } from '@/feature/cart/services/cart.routing'

/**
 * Check if the current path is a checkout page.
 */
export const isCheckoutPath = (pathname: string) => pathname.startsWith('/checkout')

/**
 * Check if the current path is the checkout confirmation page.
 */
export const isCheckoutConfirmationPath = (pathname: string) =>
  pathname.startsWith(toCheckoutConfirmation)

/**
 * Check if the current path is the empty cart page.
 */
export const isEmptyCartPath = (pathname: string) => pathname.startsWith('/checkout/empty')

export function toCheckout({ params, embed }: { params: Record<string, string>; embed: boolean }) {
  const searchParams: string = params ? new URLSearchParams(params).toString() : ''

  return embed ? `/embed/checkout?${searchParams}` : `/checkout?${searchParams}`
}

export const toCheckoutEmpty = ({ embed }: { embed: boolean }) =>
  `${embed ? '/embed' : ''}/checkout/empty`

/**
 * Go to the iDEAL payment redirection page for the given cart.
 */
export function toCheckoutRedirectPayment(cartId: string) {
  const params = new URLSearchParams({ cartId })

  return `/checkout/redirect-payment?${params.toString()}`
}
